import { HttpInterceptorFn } from '@angular/common/http';

const KEY = 'sip_visit';

/** Codice casuale della visita (vale finché si tiene aperta la scheda del browser): non identifica la persona, serve ai partner per vedere i percorsi anonimi. */
function visitId(): string | null
{
  try
  {
    let id = sessionStorage.getItem(KEY);
    if ( !id )
    {
      id = crypto.randomUUID();
      sessionStorage.setItem(KEY, id);
    }
    return id;
  }
  catch
  {
    return null;
  }
}

export const visitInterceptor: HttpInterceptorFn = (req, next) =>
{
  const id = req.url.includes('/api/public/') ? visitId() : null;
  return next(id ? req.clone({ setHeaders: { 'X-Visitor-Id': id } }) : req);
};
